export default {
	TEXTAREA: 'textarea',
	SAVE_FILE: 'save_file',
	TUTORIAL: 'tutorial'
};


// WEBPACK FOOTER //
// ./src/enums/pages.js